<section class="landing-page">
  <img src="/assets/logos/BFH_Logo.png" alt="BFH Logo" class="logo-bfh" />
  <div class="landing-card">
    <div class="landing-card-content">
      <h1 class="landing-title">Me and My Planet</h1>
      <h2 class="landing-subtitle">Discover Your Carbon Footprint</h2>

      <div class="login-container">
        <button
          class="btn btn-login-large"
          (click)="authService.loginWithOidc()"
          style="background-color: #1f2e61"
        >
          Login with
          <img
            class="icon"
            src="assets/icons/eduidbutton_neg.svg"
            height="50"
            alt="edu-ID icon"
          />
        </button>
        <button
          class="btn btn-login-small"
          (click)="authService.loginWithOidc()"
          style="background-color: #1f2e61"
        >
          Login with
          <img
            class="icon"
            src="assets/icons/eduid-circe-neg.svg"
            height="60"
            alt="edu-ID icon"
          />
        </button>
        <!-- Deprecated JWT authentication - commented out for potential future reintegration.
          For the moment, we decided to only user Switch-Authentication
          for the first version at least.
          
        <p>Don't have a Switch edu-ID?</p>
        <p><a href="/login">Log in</a> or <a href="/register">Sign Up</a></p> -->
      </div>
    </div>
  </div>

  <h1 id="tracking-title">
    Track your behaviour, recognize patterns,<br />
    and see how small changes can make a big difference.
  </h1>

  <div class="grid-container">
    <app-card>
      <div class="info-container">
        <img
          src="assets/illustrations/phone.png"
          alt="Phone interaction illustration"
        />
        <div class="info-text">
          <h2>About Me and My Planet</h2>
          <p>
            <strong><i>Me and My Planet</i></strong> is an online tool within a
            broader educational initiative, helping students and professionals
            understand and reduce their ecological footprint. Based on Education
            for Sustainable Development (ESD), the project blends personal
            reflection, hands-on learning, scientific analysis, and
            collaborative exploration of sustainable lifestyles.
          </p>
          <p>
            The main goal is to encourage individual and collective change by
            letting participants measure, analyze, and reflect on their habits
            in areas like mobility, food, housing, digitalization, and non-food
            products.
          </p>
        </div>
      </div>
    </app-card>
    <app-card>
      <div class="info-container">
        <img
          src="assets/illustrations/CO2.png"
          alt="CO₂ emissions illustration"
        />
        <div class="info-text">
          <h2>Educational Concept</h2>
          <p>
            This modular program offers detailed ecological footprint tracking,
            reflection opportunities, gamification, and a variety of
            interdisciplinary teaching materials. These resources adapt to the
            needs of tertiary education and adult learning environments.
          </p>
          <p>
            Ultimately, <strong><i>Me and My Planet</i></strong> aims to support
            a shift toward sustainable living by equipping people with the
            knowledge and motivation to act as informed change agents in their
            personal and professional lives.
          </p>
        </div>
      </div>
    </app-card>
  </div>

  <div class="contact-container">
    <h1>Want More Information or Have Questions?</h1>
    <p>
      If you’re curious to learn more about this project or if you have any
      questions, we’re here to help! Feel free to reach out, and we’ll get back
      to you as soon as possible.
    </p>
    <a href="mailto:sustainability@bfh.ch" style="text-decoration: none"
      ><button class="btn btn-accent">Get in Touch</button></a
    >
  </div>
</section>
